import React, { useRef, useState } from 'react';
import { Check, Link as LinkIcon } from 'react-feather';

const UrlField = ({ url, onApply }) => {
	const [pasted, setPasted] = useState('');
	const [copied, setCopied] = useState(false);
	const copiedTimer = useRef(null);
	const hasUrl = !!url;

	const copy = async () => {
		try {
			if (navigator.clipboard) await navigator.clipboard.writeText(url);
		} catch (e) {
			// no-op — clipboard not available
		}
		setCopied(true);
		clearTimeout(copiedTimer.current);
		copiedTimer.current = setTimeout(() => setCopied(false), 1400);
	};

	const apply = () => {
		const v = pasted.trim();
		if (!v) return;
		onApply(v);
		setPasted('');
	};

	return (
		<div className="image-upload-control__url-field">
			<label className="image-upload-control__url-label" htmlFor="image-upload-url-input">
				<LinkIcon size={13} />
				<span>Logo URL</span>
			</label>
			{hasUrl ? (
				<div className="image-upload-control__url-row">
					<input
						id="image-upload-url-input"
						className="image-upload-control__url-input is-readonly"
						readOnly
						value={url}
						title={url}
						onFocus={(e) => e.target.select()}
					/>
					<button
						type="button"
						className={`image-upload-control__url-copy${copied ? ' is-copied' : ''}`}
						onClick={copy}
						aria-label="Copy bucket URL"
					>
						{copied ? (
							<>
								<Check size={14} /> Copied
							</>
						) : (
							'Copy'
						)}
					</button>
				</div>
			) : (
				<div className="image-upload-control__url-row">
					<input
						id="image-upload-url-input"
						className="image-upload-control__url-input"
						value={pasted}
						onChange={(e) => setPasted(e.target.value)}
						placeholder="Paste an image URL, or upload above"
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault();
								apply();
							}
						}}
					/>
					<button
						type="button"
						className="image-upload-control__url-use"
						onClick={apply}
						disabled={!pasted.trim()}
					>
						Use
					</button>
				</div>
			)}
			<div className="image-upload-control__url-hint">
				{hasUrl
					? 'Stored in your media bucket. This URL is saved with the portfolio.'
					: 'Uploaded images are stored in your bucket and the URL appears here automatically.'}
			</div>
		</div>
	);
};

export default UrlField;
